"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// The value is expected to be a string
// Removes any non-numeric characters from the phone number
var cleansePhoneNumber = value => value.replace(/\D/g, '').replace(/^1/, '').slice(0, 10);
var formatPhoneNumber = value => {
  var phoneNumber = value;
  if (!phoneNumber) {
    return '';
  }
  if (phoneNumber.startsWith('1')) {
    phoneNumber = phoneNumber.slice(1);
  }
  if (phoneNumber.length <= 3) {
    return "+1".concat(phoneNumber);
  }
  if (phoneNumber.length <= 6) {
    return phoneNumber.replace(/(\d{3})(\d{0,3})/, '+1($1)-$2');
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{0,4})/, '+1($1) $2-$3');
};
var validate = (value, isRequired) => {
  var isValid = true;
  // First check if the field is required
  // if so, then check to make sure value is not empty
  isValid = isValid && (isRequired ? value !== '' : true);

  // Ensure the value is a valid phone number
  // Or in the case of field not being required(checked above): undefined
  isValid = isValid && (_constants.PHONE_NUMBER_REGEX_VALIDATION.test(value) || value === '');
  return isValid;
};
var PhoneNumberField = props => {
  var {
    label = _staticContent.PHONE_NUMBER_FIELD.DEFAULT_LABEL,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    placeholder = '',
    isRequired = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    customErrorMessage = '',
    onChange = () => {},
    // function signature: (value, isValid) => {},
    clickedSubmit,
    value = '',
    isReadOnly = false,
    prefix = '+1'
  } = props;
  var [formattedPhoneNumber, setFormattedPhoneNumber] = (0, _react.useState)(formatPhoneNumber(cleansePhoneNumber(value)));
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  var customPlaceholder = placeholder || _staticContent.PHONE_NUMBER_FIELD.PLACEHOLDER;
  var updateValidationError = (0, _react.useCallback)(isValid => {
    setValidationError(isValid ? undefined : customErrorMessage || _staticContent.PHONE_NUMBER_FIELD.VALIDATION_ERROR[language]);
    setValidationFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
  }, [customErrorMessage, language]);
  (0, _react.useEffect)(() => {
    onChange(value, validate(value, isRequired));
  }, [isRequired, onChange, value]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      var cleansedNumber = cleansePhoneNumber(value);
      var isValid = validate(cleansedNumber, isRequired);
      updateValidationError(isValid);
    }
  }, [clickedSubmit, isRequired, updateValidationError, value]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        var cleansedNumber = cleansePhoneNumber(value);
        var isValid = validate(cleansedNumber, isRequired);
        updateValidationError(isValid);
      }
    }
  }, [buttonControlPressed, currentStepReferences, inputRef, isRequired, updateValidationError, value]);
  var onFieldChange = val => {
    var cleansedNumber = cleansePhoneNumber(val);
    setFormattedPhoneNumber(formatPhoneNumber(cleansedNumber));
    var phoneNumberAfterPrefix = prefix === 'No Prefix' ? cleansedNumber : "".concat(prefix).concat(cleansedNumber);
    onChange(phoneNumberAfterPrefix, validate(cleansedNumber, isRequired));
  };
  var onFieldBlur = e => {
    var cleansedNumber = cleansePhoneNumber(e.target.value);
    var isValid = validate(cleansedNumber, isRequired);
    updateValidationError(isValid);
  };
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextInput, {
    ref: inputRef,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    hint: hint,
    hintPosition: hintPosition,
    placeholder: customPlaceholder,
    value: formattedPhoneNumber,
    type: _constants.INPUT_FIELD_TYPE.PHONE,
    onChange: onFieldChange,
    onBlur: onFieldBlur,
    feedback: validationError,
    validation: validationFeedback,
    autoComplete: "tel",
    keyboardType: "numeric",
    "data-di-mask": true,
    inactive: isReadOnly
  }));
};
PhoneNumberField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  clickedSubmit: _propTypes.default.bool,
  language: _propTypes.default.string,
  inputRef: _propTypes.default.object,
  customErrorMessage: _propTypes.default.string
};
var _default = exports.default = PhoneNumberField;